import { User, UserFormData, UsersResponse } from '@/types/user'
import { apiService } from './api'

interface GetUsersParams {
  search?: string
  page?: number
  limit?: number
  role?: string
  status?: string
}

interface LoginResponse {
  access_token: string
}

class UserService {
  async getUsers(params: GetUsersParams = {}): Promise<UsersResponse> {
    const data: any = await apiService.get('/admin/users', { params });
    let usersArr: User[] = [];
    let total = 0, page = 1, limit = 10, totalPages = 1;
    if (Array.isArray(data)) {
      usersArr = data;
    } else if (Array.isArray(data?.results)) {
      usersArr = data.results;
      total = data?.total || 0;
      page = data?.page || 1;
      limit = data?.limit || 10;
      totalPages = data?.totalPages || 1;
    }
    return {
      users: usersArr,
      total,
      page,
      limit,
      totalPages,
    };
  }

  async getUser(id: string): Promise<User> {
    const data = await apiService.get<User>(`/admin/users/${id}`)
    return data
  }

  async createUser(data: UserFormData): Promise<User> {
    const responseData = await apiService.post<User>('/admin/users', data)
    return responseData
  }

  async updateUser(id: string, data: UserFormData): Promise<User> {
    const responseData = await apiService.put<User>(`/admin/users/${id}`, data)
    return responseData
  }

  async deleteUser(id: string): Promise<void> {
    await apiService.delete(`/admin/users/${id}`)
  }

  async resetPassword(id: string): Promise<void> {
    await apiService.post(`/admin/users/${id}/reset-password`)
  }

  async verifyEmail(id: string): Promise<void> {
    await apiService.post(`/admin/users/${id}/verify-email`)
  }

  // Auth methods - these should use the auth service instead
  async login(email: string, password: string): Promise<LoginResponse> {
    const data = await apiService.post<LoginResponse>('/auth/login', { email, password }, { isPublic: true })
    localStorage.setItem('access_token', data.access_token)
    return data
  }

  async logout(): Promise<void> {
    await apiService.post('/auth/logout', undefined, { isPublic: true })
    localStorage.removeItem('access_token')
  }

  async getCurrentUser(): Promise<User> {
    const data = await apiService.get<User>('/auth/user', { isPublic: true })
    return data
  }
}

export const userService = new UserService() 